const URL = process.env.REACT_APP_URL;
export const AUTH_PAYMENT_URL = URL + '/v1/transactions/authorize';
export const getBanks = (type: string) =>
  URL + `/v1/financial-institutions?type=${type}`;
export const markedAsDisplayed = (transactionRef: string) =>
  URL + `/v1/transactions/${transactionRef}/mark-as-displayed`;
export const getDetailsByTxnRefUrl = (transactionRef: string) =>
  URL + `/v1/transactions/${transactionRef}`;
export const getDetailsByBoostTagUrl = (boostTag: string) =>
  URL + `/v1/tags/${boostTag}`;
export const getTransactionByAnonymousUrl = () =>
  URL + '/v1/transactions/by-anonymous';
